import { memo, useCallback } from 'react';
import { Flex, Switch, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { getPlannerMode, handlePlannerMode } from 'redux/PlannerModeSlice';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';
import BuilderModeSvgIcon from '../icons/BuilderModeSvgIcon';

const BuilderModeToggle = memo(() => {
  const dispatch = useDispatch();
  const isBuilderModeOn = useSelector(getPlannerMode);

  const handleToggle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(handlePlannerMode(event.target.checked));
    },
    [dispatch],
  );

  return (
    <Flex
      as='label'
      align='center'
      gap={BUILDER_MODE_V1_LAYOUT.builderToggleGap}
      px={BUILDER_MODE_V1_LAYOUT.actionButtonPaddingX}
      h={BUILDER_MODE_V1_LAYOUT.actionButtonHeight}
      minH={BUILDER_MODE_V1_LAYOUT.actionButtonHeight}
      bg={BUILDER_MODE_V1_TOKENS.textDark}
      borderRadius={BUILDER_MODE_V1_LAYOUT.actionButtonRadius}
      cursor='pointer'
      flexShrink={0}
      boxSizing='border-box'
    >
      <BuilderModeSvgIcon name='wrench' />
      <Text
        fontSize='14px'
        fontWeight='400'
        color={BUILDER_MODE_V1_TOKENS.white}
        whiteSpace='nowrap'
        lineHeight='normal'
      >
        Builder mode
      </Text>
      <Switch
        size='sm'
        isChecked={isBuilderModeOn}
        onChange={handleToggle}
        colorScheme='purple'
        sx={{
          '& .chakra-switch__track': {
            w: '25px',
            h: '15px',
            bg: BUILDER_MODE_V1_TOKENS.white,
            _checked: { bg: BUILDER_MODE_V1_TOKENS.white },
          },
          '& .chakra-switch__thumb': {
            w: '13px',
            h: '13px',
            bg: isBuilderModeOn
              ? BUILDER_MODE_V1_TOKENS.primary
              : BUILDER_MODE_V1_TOKENS.placeholder,
            _checked: { transform: 'translateX(10px)' },
          },
        }}
      />
    </Flex>
  );
});

BuilderModeToggle.displayName = 'BuilderModeToggle';

export default BuilderModeToggle;
